export default "__VITE_ASSET__c54cbc72__"